// Auto-sized logos formerly took their display width from Next’s selected
// Contentful rendition. Keep those boxes while delivering the original bytes.
const LEGACY_IMAGE_WIDTHS = [
  32, 48, 64, 96, 128, 256, 384, 640, 750, 828, 1080, 1200, 1920, 2048, 3840,
];

export const legacyImageDisplayWidth = (width: number, density: 1 | 2 = 1) =>
  (LEGACY_IMAGE_WIDTHS.find((size) => size >= width * density) ??
    LEGACY_IMAGE_WIDTHS.at(-1)!) / density;
